import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { FaqService } from "../../services/faq.service";
import AppConstants from "../../constants/AppConstants";

@Component({
  selector: "app-faqs",
  templateUrl: "./faqs.component.html",
  styleUrls: ["./faqs.component.scss"],
})
export class FaqsComponent implements OnInit {
  faqs = [];
  searchQuery = "";
  count: number;
  readonly DEFAULT_PAGE_SIZE = AppConstants.DEFAULT_PAGE_SIZE;
  readonly DEFAULT_PAGE_SIZE_OPTIONS = AppConstants.DEFAULT_PAGE_SIZE_OPTIONS;
  readonly DEFAULT_PAGINATION_INFO = { pageIndex: 0, pageSize: 10 };
  pageIndex = 0;
  pageCursors: any[] = [];
  currentPageSize = 10;

  constructor(
    private graphqlService: FaqService,
    private route: ActivatedRoute,
  ) {
    route.params.subscribe((val) => {
      this.fetchList(this.DEFAULT_PAGINATION_INFO);
    });
  }

  pageChanged({ pageIndex, pageSize }) {
    this.fetchList(
      {
        pageIndex,
        pageSize,
      },
      this.searchQuery,
    );
  }

  search(input) {
    this.pageIndex = 0;
    this.pageCursors = [];
    this.fetchList({ pageIndex: 0, pageSize: this.currentPageSize }, input);
  }

  private fetchList(pageInfo, searchParam?: string) {
    this.pageIndex = pageInfo.pageIndex;
    const cursorForPage = this.pageIndex > 0 ? this.pageCursors[this.pageIndex - 1] : undefined;
    const obj = {
      paginationData: {
        pageIndex: pageInfo.pageIndex,
        pageSize: pageInfo.pageSize,
        after: cursorForPage,
      },
      searchParam: searchParam,
    };
    this.graphqlService.list(obj).subscribe((result) => {
      console.log(result, "faqs");
      if (result && result.data) {
        this.faqs = result.data["faqs"].edges.map((edge) => edge.node);
        this.count = result.data["faqs"].totalCount;
        this.pageCursors[this.pageIndex] = result.data["faqs"].pageInfo;
      }
      
    });
  }

  ngOnInit() {}
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/faqs/faqs.component.ts